import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationStepperComponent } from 'app/components/application-stepper/application-stepper.component';
import { FooterComponent } from 'app/components/footer/footer.component';
import { HeaderComponent } from 'app/components/header/header.component';

@Component({
    selector: 'non-eligible',
    templateUrl: './non-eligible.component.html',
    styleUrls: ['./non-eligible.component.scss'],
    standalone: true,
    imports: [
        FormsModule,
        CommonModule,
        MatIconModule,
        TranslateModule,
        ReactiveFormsModule,
        HeaderComponent,
        FooterComponent,
        MatDividerModule,
        ApplicationStepperComponent,
    ],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
})
export class NonEligibleComponent {
    selectedLanguage: any;
    isAuthenticated: boolean = false;

    value = 35;

    constructor(private router: Router) {
        this.isAuthenticated =
            localStorage.getItem('isAuthenticated') == 'true' ? true : false;
    }

    ngOnInit() {
        this.selectedLanguage = localStorage.getItem('language');
        if (this.isAuthenticated == false) {
            this.router.navigate(['/login']);
        }
    }

    goToHome() {
        this.router.navigate(['/home']);
    }

    switchedLanguage(data: any) {
        this.selectedLanguage = data;
    }
}
